module.exports = (__webpack_require__(52373))(2543);